import { GetterTree } from 'vuex';
import RootState from './RootState';
import TMAlert from '@/tools/models/TMAlert';
import User from '@/tools/models/User';

const getters: GetterTree<RootState, RootState> = {
  alert: (state): TMAlert => state.alert,
  user: (state): User => state.user,
  luckySpins: (state): number => state.user.gifts,
  initialMessageShown: (state): boolean => state.intialMessageShown,
};

export default getters;
